import { ProductAbbreviation } from './ProductAbbrevation';

export default ProductAbbreviation;
